import { DataTable } from '../../components/ui'
import { dedicatedReportsApi } from '../../api/dedicatedReports'
import { DedicatedReportShell, Limitations, pct } from './DedicatedReportShell'

/** R3-22 — backoffice: code di oggi, eccezioni, SLA sforati e lotti del periodo. */
export function BackofficeReportPage() {
  return (
    <DedicatedReportShell title="Report backoffice" icon="support_agent" load={dedicatedReportsApi.backoffice}>
      {d => (
        <>
          <div className="text-muted md-typescale-body-small mb-2">Dal {d.period.from} al {d.period.to}. Le code sono la fotografia di oggi.</div>
          <DataTable>
            <thead><tr><th>Misura</th><th className="text-end md-num">Valore</th></tr></thead>
            <tbody>
              {d.queue.map(q => <tr key={q.key}><td>{q.label}</td><td className="text-end md-num">{q.n}</td></tr>)}
              <tr><td>Eccezioni create</td><td className="text-end md-num">{d.exceptions.created}</td></tr>
              <tr><td>Eccezioni risolte</td><td className="text-end md-num">{d.exceptions.resolved}</td></tr>
              <tr><td>Tasso di risoluzione</td><td className="text-end md-num">{pct(d.exceptions.resolutionRate)}</td></tr>
              <tr><td>SLA sforati</td><td className="text-end md-num">{d.sla.breached}</td></tr>
              <tr><td>Lotti creati</td><td className="text-end md-num">{d.batches.created}</td></tr>
              <tr><td>Lotti in attesa di approvazione</td><td className="text-end md-num">{d.batches.pending}</td></tr>
              <tr><td>Lotti approvati</td><td className="text-end md-num">{d.batches.approved}</td></tr>
              <tr><td>Lotti rifiutati</td><td className="text-end md-num">{d.batches.rejected}</td></tr>
              <tr>
                <td>Tempo mediano di approvazione (ore)</td>
                <td className="text-end md-num">{d.batches.medianApprovalHours === null ? '—' : d.batches.medianApprovalHours.toLocaleString('it-IT')}</td>
              </tr>
            </tbody>
          </DataTable>
          <Limitations items={d.limitations} />
        </>
      )}
    </DedicatedReportShell>
  )
}
